import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {buildFormGroup} from '@aviary/forms/form.helpers';
import {InputFormFieldComponent} from '@aviary/forms/fields/input-form-field/input-form-field.component';
import {RegistrationActions} from '@store/registration/registration.actions';
import {FALLBACK_CARD_LOGIN_VALUE} from '@store/patron/patron.fallback';
import {PatronValidators} from '@store/patron/patron.validators';
import {MatCard, MatCardContent} from '@angular/material/card';
import {NgOptimizedImage} from '@angular/common';
import {FilledButtonComponent} from '@aviary/buttons/filled-button/filled-button.component';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {LinkButtonComponent} from '@aviary/buttons/link-button/link-button.component';
import {ButtonRouteNameDirective} from '@lib/directives/button-route-name/button-route-name.directive';

@Component({
  selector: 'px-lookup-account-form',
  host: {
    class: 'flex flex-row gap-x-4 items-center justify-center md:justify-between lg:pl-10 lg:pr-20'
  },
  templateUrl: './registration-lookup-account-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    InputFormFieldComponent, MatCard, MatCardContent, NgOptimizedImage, FilledButtonComponent, SelectPipe, LinkButtonComponent, ButtonRouteNameDirective
  ]
})
export class RegistrationLookupAccountFormComponent {
  public readonly viewportSelectors = ViewportSelectors;
  public readonly lookupForm: ExtendedFormGroup = buildFormGroup(FALLBACK_CARD_LOGIN_VALUE, inject(PatronValidators).cardLogin);
  public readonly store = inject(Store);

  public onClickNext() {
    const value = this.lookupForm.value;
    this.store.dispatch(RegistrationActions.lookupAccount(value.cardNumber, value.pin));
  }
}
